import React from 'react'
import { useCalculator } from '../use-calculator'
import { fmt, arrayFrom, parseDate } from '../../twd'

export const CouponsFirstYear = () => {

    const { calcOutput:co, bondInfo:bi, calcInput:ci } = useCalculator()

    const firstYear = arrayFrom(co.paymentsFirstYear)
        .reduce( (x, r) => ({
            ...x,
            ...{ [fmt.fmtDt(r.date, 'MMMM yyyy')] : r }
        }), {})

    const issue = (bi || {}).issue
    const mat = parseDate(issue.maturity)
    const now = parseDate((ci || {}).settlement) || new Date()
    const payments = [...Array(12).keys()]
        .map((i) => {
            const d = new Date(now.getFullYear(), now.getMonth() + i, 1)
            if (d > mat) return null

            const ds = fmt.fmtDt(d, 'MMMM yyyy')
            return Object.assign({
                dateStr: ds,
                principal: 0,
                interest: 0
            }, firstYear[ds])
        })
        .filter(Boolean)

    const total = payments
        .reduce((x, {interest, principal}) => x + interest + principal, 0)

    return <React.Fragment>
        <div className='table-responsive'>
        <table className='table table-striped coupon-payments' style={{marginBottom: 0}}>
            <thead>
                <tr>
                    <th>Date</th>
                    <th className='text-right'>Payment amount</th>
                </tr>
            </thead>
            <tbody>
                {payments.map(({dateStr, interest, principal}, i) => {
                    return <tr key={i}>
                        <td>{dateStr} {interest && principal ? '*' : ''}</td>
                        <td className="text-right">
                            {fmt.money(interest + principal)}
                        </td>
                    </tr>
                })}
            </tbody>
            <tfoot>
                <tr>
                    <td className="text-bold">Total</td>
                    <td className="text-bold text-right">{fmt.money(total)}</td>
                </tr>
            </tfoot>
        </table>
        </div>
        <div className="vertical-offset-base">
        * Includes interest and principal payment
        </div>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/calculator/calc-coupons/coupons-first-year.js